import { createSlice } from "@reduxjs/toolkit";
import getQualityIndicators from "@custom/rtk-apis/qualityIndicators";

const initialState = {
    status: "",
    result: null,
    msg: "",
    loading: false,
    error: ""
};

const getQualityIndicatorsSlice = createSlice({
    name: "getQualityIndicatorsSlice",
    initialState,
    reducers: {
        clearQualityIndicatorsState: state => {
            state.status = '';
            state.result = null;
            state.msg = '';
            state.loading = false;
            state.error = '';
        },
        closeQualityIndicatorsModal: state => {
            state.status = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getQualityIndicators.pending, (state, action) => {
                state.loading = true;
                state.status = 'PENDING';
            })
            .addCase(getQualityIndicators.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload;
                state.msg = payload.msg;
            })
            .addCase(getQualityIndicators.rejected, (state, action) => {
                state.result = null;
                state.loading = false;
                state.status = 'FAILED';
                state.error = action.error.message;
            });
    },
});

export default getQualityIndicatorsSlice.reducer;
export const { clearQualityIndicatorsState, closeQualityIndicatorsModal } = getQualityIndicatorsSlice.actions;
